import { Avatar, Link, Stack, Typography } from '@mui/material';
import { getDisabilityConfirmationPdf } from 'API/disabilityConfirmation';
import { Loader } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  Download,
  LeftArrow,
  UniversalRequestFullPurpleExclamationMark,
} from 'Images';
import { downloadFile } from 'Utils';
import { useState } from 'react';

interface IPersonalAreaRecommendation {
  description?: string;
  linkLabel?: string;
  linkUrl: string;
  isDownload?: boolean;
  isDisabledVeteran: boolean;
}

export const PersonalAreaRecommendation = ({
  description,
  linkLabel,
  linkUrl,
  isDownload,
  isDisabledVeteran,
}: IPersonalAreaRecommendation) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.UniversalRequest
  ).personalAreaRecommendation;
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack
      width={isDesktop ? '680px' : 'calc(100% - 48px)'}
      p={isDesktop ? '24px' : '16px'}
      bgcolor={isDesktop ? 'white' : '#FBF6FF'}
      border='1px solid #B756FF'
      m='0 auto'
      direction='row'
      gap='8px'
      borderRadius='12px'
      mt='60px'
    >
      <Avatar
        src={UniversalRequestFullPurpleExclamationMark}
        alt=''
        sx={{ width: '24px', height: '24px' }}
      />
      <Stack>
        <Typography
          fontWeight='700'
          fontSize={isDesktop ? '20px' : '18px'}
          lineHeight='24px'
        >
          {isDownload || isDisabledVeteran
            ? dictionary.downloadTitle
            : dictionary.title}
        </Typography>
        {!(isDownload || isDisabledVeteran) && (
          <Typography
            maxWidth='52ch'
            mt={isDesktop ? '8px' : '4px'}
            fontSize={isDesktop ? '20px' : '18px'}
            lineHeight='24px'
          >
            {description || dictionary.subtitle}
          </Typography>
        )}
        <Link
          href={isDownload ? undefined : linkUrl || dictionary.linkURL}
          sx={{
            display: 'flex',
            mt: '4px',
            gap: '4px',
          }}
          onClick={
            isDownload
              ? async () => {
                  setIsLoading(true);
                  const id = linkUrl.split('/').pop();

                  const file = await getDisabilityConfirmationPdf(
                    parseInt(id || '')
                  );

                  if (file) downloadFile(file, 'pdf', '');

                  setIsLoading(false);
                }
              : undefined
          }
        >
          <Typography
            fontWeight='600'
            fontSize={isDesktop ? '18px' : '16px'}
            lineHeight={isDesktop ? '22px' : '20px'}
            minWidth={isLoading ? 'fit-content' : undefined}
          >
            {linkLabel || dictionary.linkText}
          </Typography>
          {isLoading ? (
            <Loader
              sx={{
                height: '100%',
                overflow: 'hidden',
                display: 'inline',
                ml: '8px',
              }}
              size={20}
            />
          ) : (
            <Avatar
              src={isDownload || isDisabledVeteran ? Download : LeftArrow}
              alt=''
              sx={{
                width: '24px',
                height: '24px',
                ml: isDesktop ? undefined : '-4px',
                mt: isDesktop ? undefined : '-2px',
              }}
            />
          )}
        </Link>
        <Typography
          mt={isDesktop ? '16px' : '12px'}
          fontWeight='600'
          fontSize={isDesktop ? '18px' : '16px'}
          lineHeight={isDesktop ? '22px' : '20px'}
        >
          {isDownload || isDisabledVeteran
            ? dictionary.DownloadContinueFromHere
            : dictionary.continueFromHere}
        </Typography>
      </Stack>
    </Stack>
  );
};
